// extracted by mini-css-extract-plugin
module.exports = {"page":"ReservationsPage_page__mgHyN","header":"ReservationsPage_header__2GnJr","heading":"ReservationsPage_heading__2y0qm","noPermissions":"ReservationsPage_noPermissions__3GK12"};